const HttpResponseHandler = {
  async createErrorResponse(error: any) {
    const { status, data, statusText } = await error.response;
    //console.log(['createErrorResponse', error, status, data, statusText])
    return {
      status: status,
      // lastUpdated: '',
      results: [],
      count: 0,
      skipped: 0,
      totalCount: 0,
      statusText: statusText || '',
      errorMessage: data && data.ExceptionMessage ? data.ExceptionMessage : '',
    };
  },

  async createResponse(response: any) {
    //console.log(['createResponse', response])
    const { status, data, statusText } = await response;
    const results = {
      status: status,
      data:
        data && data.results
          ? {
              // lastUpdated: data && data.lastUpdated ? data.lastUpdated : '',
              results: data && data.results ? data.results : [],
              count: data && data.count ? data.count : 0,
              skipped: data && data.skipped ? data.skipped : 0,
              totalCount: data && data.totalCount ? data.totalCount : 0,
            }
          : data,
      statusText: statusText || '',
      errorMessage: data && data.ExceptionMessage ? data.ExceptionMessage : '',
    };

    return results;
  },
};

export default HttpResponseHandler;
